import { render } from "./Home-page.vue?vue&type=template&id=54651494&scoped=true"
import script from "./Home-page.vue?vue&type=script&lang=js"
export * from "./Home-page.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=54651494&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54651494"]])

export default __exports__